// utils/theme.js
export function applyTheme(baseerp) {
    const themeLink = document.getElementById('dynamic-root-theme');
    if (!themeLink) return;

    // 根据 baseerp 决定加载哪个 root CSS 文件
    const themeFile = '/theme_'+baseerp+'.css';

    // 替换 href，浏览器会自动加载新的 root 变量并全局生效
    themeLink.href = themeFile;
    // 2. 动态拼接并切换 Favicon
    const faviconLink = document.getElementById('dynamic-favicon');
    if (faviconLink) {
        // 加上时间戳，防止浏览器缓存导致图标不更新
        faviconLink.href = `/favicon_${baseerp}.ico?v=${new Date().getTime()}`;
    }
}